<template>
	<AppDialog :closeRight="'-10'" :closeTop="'-30'" disableMaxWidth dialogName="IdeaDialog" width="1000px">
		<div class="dialog-content rounded display-flex flex-wrap">
			<IdeaDialogLeftSide class="flex-col-9" :idea="idea" ref="left_side" />
			<IdeaDialogRightSide @close="close" class="flex-col-3" :idea="idea" @idea-saved="ideaSaved" />
		</div>
	</AppDialog>
</template>
<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import IdeaDialogLeftSide from '@/components/dialogs/IdeaDialog/IdeaDialogLeftSide.vue';
import IdeaDialogRightSide from '@/components/dialogs/IdeaDialog/IdeaDialogRightSide.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { useIdea } from '@/store/modules/inspirationCenter/getters';
import { getIdea } from '@/store/modules/inspirationCenter/actions';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';

export default {
	name: 'IdeaDialog',
	components: {
		AppDialog,
		IdeaDialogLeftSide,
		IdeaDialogRightSide,
	},
	props: {
		dialogPromiseHandlers: { type: Object },
		ideaId: { type: String },
	},
	computed: {
		...mapGettersShorthand({ useIdea }),
		idea() {
			return this.useIdea(this.ideaId);
		},
	},
	methods: {
		...mapActionsShorthand({ getIdea }),
		close() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
		ideaSaved() {
			this.$nextTick(() => {
				this.$refs.left_side.focusPostCommentInput();
			});
		},
	},
	async mounted() {
		await this.getIdea({ ideaId: this.ideaId });
	},
};
</script>

<style scoped lang="scss">
$right-side-width: 230px;
.dialog-content {
	height: 700px;
	max-height: 90vh;
	overflow: hidden;
	background: var(--white);
}

.rounded {
	border-radius: 16px;
}
</style>
